import adminApiClient from './adminApiClient';

export const adminRbacService = {
  getPermissions:  ()          => adminApiClient.get('/api/admin/permissions'),
  getRoles:        ()          => adminApiClient.get('/api/admin/roles'),
  createRole:      (data)      => adminApiClient.post('/api/admin/roles', data),
  updateRole:      (id, data)  => adminApiClient.put(`/api/admin/roles/${id}`, data),
  deleteRole:      (id)        => adminApiClient.delete(`/api/admin/roles/${id}`),
};

export default adminRbacService;
